import { render, staticRenderFns } from "./DropzoneFileUpload.vue?vue&type=template&id=148f5e2e&scoped=true&"
import script from "./DropzoneFileUpload.vue?vue&type=script&lang=js&"
export * from "./DropzoneFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./DropzoneFileUpload.vue?vue&type=style&index=0&id=148f5e2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f5e2e",
  null
  
)

export default component.exports